import { Box, Button, Link, Typography } from "@mui/material";
import { EConfirmModalType, LoadingButton } from "src/shared/components";
import { modalText } from "src/shared/constants/form.constants";
import { useConfirmModal } from "src/shared/hooks";
import { Can } from "src/shared/lib/rback/Can";

interface IAgreementDialogFooterProps {
  isEdit?: boolean;
  isLoading: boolean;
  isLoadingDelete?: boolean;
  isLoadingExport?: boolean;
  attachmentUrl?: string;
  onDelete?: () => void;
  onExport?: () => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export function AgreementDialogFooter({
  isEdit,
  isLoading,
  attachmentUrl,
  isLoadingDelete,
  isLoadingExport,
  onDelete,
  onExport,
  onSubmit,
  onCancel,
}: IAgreementDialogFooterProps) {
  const { modal, showModal } = useConfirmModal({
    onResolve: onDelete,
    confirmModalType: EConfirmModalType.WARNING,
    confirmBtnProps: {
      isLoading: isLoadingDelete || false,
      title: modalText.continue,
    },
    children: (
      <Typography>Вы действительно хотите удалить соглашение?</Typography>
    ),
    title: modalText.confirmAction,
  });

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: { xs: "column", lg: "row" },
        gap: 4,
      }}
    >
      {modal}

      {isEdit && (
        <Box
          sx={{
            alignItems: { xs: "flex-start", md: "unset" },
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column-reverse", md: "row" },
          }}
        >
          {onDelete && (
            <Can perform={"partners.contract.delete"}>
              <Button color="warning" variant="contained" onClick={showModal}>
                Удалить соглашение
              </Button>
            </Can>
          )}
          {onExport && (
            <LoadingButton
              variant="outlined"
              isLoading={isLoadingExport || false}
              onClick={onExport}
            >
              Скачать шаблон
            </LoadingButton>
          )}
          {attachmentUrl && (
            <Box
              sx={{
                display: "flex",
                gap: 2,
              }}
            >
              <Button
                target="_blank"
                variant="outlined"
                component={Link}
                href={attachmentUrl}
                download
              >
                Экспортировать
              </Button>

              <Button
                variant="outlined"
                onClick={() => {
                  window.open(attachmentUrl, "_blank", "width=740,height=400");
                }}
              >
                Печать
              </Button>
            </Box>
          )}
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          gap: 2,
          ml: "auto",
          justifyContent: { xs: "flex-end", lg: "unset" },
        }}
      >
        <LoadingButton
          sx={{ ml: 2 }}
          isLoading={isLoading}
          variant="contained"
          onClick={onSubmit}
          disabled={isLoading}
        >
          {`Сохранить${isEdit ? " изменения" : ""}`}
        </LoadingButton>

        <Button variant="outlined" onClick={onCancel}>
          Закрыть
        </Button>
      </Box>
    </Box>
  );
}
